// extracted by mini-css-extract-plugin
var _1 = "ExpiredUserEmptyState_container__b9L3K";
var _2 = "ExpiredUserEmptyState_header__A1LW0";
export { _1 as "container", _2 as "header" }
